window.VegasListener = {
	onReady: () => {
		Vegas.carousel();
		Vegas.enablePlugins();
		Vegas.other();
		Vegas.fixedScrollTo($(window));
		Vegas.clones();
	},

	onLoad: () => {
		Vegas.preloader();
	},

	onClick: () => {
		Vegas.popup();
	},

	onScroll: ($self) => {
		Vegas.fixedScrollTo($self);
	},
};

window.Vegas = {
	log: function () {
		console.group('vegas studio');
		console.log("%cvegas app was initialization","color: green;");
		console.log('https://vegas-dev.com/');
		console.groupEnd();
	},

	preloader: function () {

	},

	enablePlugins: function () {
		// navigation
		new VGNav({
			expand: 'md',
			toggle: '<i class="fal fa-chevron-down"></i>',
			//mobileTitle: 'Навигация'
		});

		// animation
		AOS.init({
			once: true,
		});

		$('.btn-load-more-portfolios').each(function () {
			$(this).vegasLoadMore({
				limit: $(this).data('limit'),
				offset: $(this).data('offset'),
				onLoad: function ($self, data) {
					let target = $self.attr('data-target');

					$(target).append(data.view);

					if (!data.view || data.photos_count <= 9) {
						$self.hide();
					}
				},
				onClick: function ($self) {
					$self.text('Загружаю...')
				}
			});
		})
	},

	popup: function () {
		$('[data-modal]').click(function () {
			ModalVegas.init($(this));

			return false;
		});
	},

	carousel: function () {
		VegasCarousel.init();
	},

	other: function () {
		// default page
		let $pageText = $('.vg-page-default, .page-default'),
			$table = $pageText.find('table');

		$table.addClass('table table-hover table-striped');
		$table.wrap('<div class="table-responsive"></div>');
		$pageText.find('br').after('<span class="mb-5 d-block"></span>');
		$pageText.find('img').addClass('img-fluid');
	},

	fixedScrollTo: function ($self) {
		let $sticky = $('.vg-scroll-top'),
			scroll = $self.scrollTop();

		if (scroll > 400) {
			$sticky.addClass('is-active');
		} else {
			$sticky.removeClass('is-active');
		}
	},

	clones: function () {
		if (window.innerWidth < 1199) {
			let $obj_categories_clone = $('.vg-accessory-sidebar--body');
			if ($obj_categories_clone.length) {
				$obj_categories_clone.clone(true).detach();
				$('.vg-categories-clone-area').append($obj_categories_clone)
			}
		}
	}
};
